import { Injectable } from "@angular/core";
import { PersistedStoreConfig } from '@persistence/persisted-store-config';
import { ID } from "@common/interfaces/id";
import { IPortaleContratti } from "@common/interfaces/interfaceData";
import { Topics } from "@common/interfaces/topics";
import { EntityState, EntityStore } from "@datorama/akita";
import { InterfaceDataStore } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

export interface IIDPortaleContrattiState extends EntityState<IPortaleContratti, ID> { }

@Injectable({
  providedIn: 'root'
})
@PersistedStoreConfig({ name: Topics.IID_PORTALE_CONTRATTI })
@InterfaceDataStore(InterfaceName.PORTALE_CONTRATTI)
export class IIDPortaleContrattiStore extends EntityStore<IIDPortaleContrattiState> {
  constructor() {
    super([]);
  }
}
